import type { FC } from 'react';
import React, { Suspense } from 'react';
import styled, { css } from 'styled-components';

const HotelNotice = React.lazy(
  () =>
    import(
      /* webpackChunkName: "HotelNotice" */ '@lt/components/components/HotelNotice'
    ),
);

interface NoticeProps {
  notices: Array<string>;
  marginBottom?: number;
  marginTop?: number;
}

const Notices: FC<NoticeProps> = ({
  notices = [],
  marginBottom = 8,
  marginTop = 8,
}) => (
  <ul>
    {notices?.map((item) => (
      <StyledListItem
        $marginBottom={marginBottom}
        $marginTop={marginTop}
        key={item}
      >
        <Suspense fallback={null}>
          <HotelNotice text={item} />
        </Suspense>
      </StyledListItem>
    ))}
  </ul>
);

const StyledListItem = styled.li<{
  $marginBottom: number;
  $marginTop: number;
}>`
  ${({ $marginBottom, $marginTop }) =>
    css`
      margin-bottom: ${$marginBottom}px;
      margin-top: ${$marginTop}px;
    `}
`;

export default Notices;
